import { render } from "./CreateJob.vue?vue&type=template&id=49b298d2&scoped=true"
import script from "./CreateJob.vue?vue&type=script&lang=js"
export * from "./CreateJob.vue?vue&type=script&lang=js"

import "./CreateJob.vue?vue&type=style&index=0&id=49b298d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b298d2"]])

export default __exports__